import store from '@/store'
import axios from 'axios'

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function desensitize(val) {
  return val.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
  // return val.replace(/(?<=.{2})(.)(?=.{2})/g, '*').replace(/^(.{3})(.*)(.{4})/, '$1 $2 $3')
}

export function debounce(fn, delay = 500) {
  // timer 是在闭包中的
  let timer = null

  return function () {
    const that = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(that, arguments)
      timer = null
    }, delay)
  }
}

/**
 * 将url转换成bloburl
 * @param {*} url
 * @returns
 */
export const urlToBlobUrl = async (url) => {
  const result = await axios.request({ url, responseType: 'blob' })

  const blob = new Blob([result.data], { type: result.headers['Content-Type'] })
  const objectUrl = URL.createObjectURL(blob)
  return {
    url: objectUrl,
    blob
  }
}

/**
 * 单位转换
 * @param {*} size
 * @returns
 */
export function sizeTostr(size) {
  var data = ''
  if (size < 0.1 * 1024) {
    // 如果小于0.1KB转化成B
    data = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    // 如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    // 如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    // 其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  var sizestr = data + ''
  var len = sizestr.indexOf('.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    // 当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

/**
 * 获取全链接
 * @param url
 * @returns
 */
export const getOSSFullUrl = (url) => {
  if (!url || typeof url.startsWith !== 'function') return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  const host = store.getters.publicDataHost
  if (!host) return ''
  const h = String(host).replace(/\/$/, '')
  const path = String(url).startsWith('/') ? url : `/${url}`
  return `${h}${path}`
}

/**
 * 使用x-oss-process处理图片视频
 * @returns
 */
export const xossprocess = (src, process) => {
  if (!src) return ''
  const full = getOSSFullUrl(src)
  if (!full) return ''
  try {
    const url = new URL(full)
    if (process) {
      const processParams = (url.searchParams.get('x-oss-process') || '') + process
      url.searchParams.set('x-oss-process', processParams)
    }
    return url.toString()
  } catch (e) {
    return full
  }
}

/**
 * 解析活动额外字段
 * {
  "extra": {
    "ver": "1",
    "status": {
        "resultsShowStatus":{
            "imageLive": false,
            "videoLive": false,
            "liked": false,
            "rank": false
        }
    }
  }
}

 * @param json
 */
export const competitionParseExtra = (json) => {
  const defaultExtra = {
    ver: 1,
    status: {
      resultsShowStatus: { imageLive: false, videoLive: false, liked: false, rank: false },
      detailShowStatus: { imageLive: true, videoLive: true },
      merchantShowStatus: { listItem: true, picture: false }
    }
  }
  // 定义类型，让其合并成类型
  const extra = JSON.parse(json || '{}')

  /**
   * 深度合并对象
   * @param origin
   * @param args
   */
  function merge(origin, ...args) {
    const dataType = ['bigint', 'boolean', 'function', 'number', 'string', 'symbol', 'undefined']
    for (const item of args) {
      for (const key in item) {
        const val = item[key]
        // 不是数组、不是基础类型、是对象调用合并
        // eslint-disable-next-line valid-typeof
        if (
          !Array.isArray(val) &&
          dataType.every((type) => String(typeof val) !== type) &&
          val instanceof Object &&
          origin[key] instanceof Object
        ) {
          origin[key] = merge(origin[key], val)
        } else {
          origin[key] = val
        }
      }
    }

    return origin
  }

  return merge(defaultExtra, extra)
}

/**
 * 通过指定规则输出 HTML 结构
 * @param {string} str
 * @returns 包含标签的html结构
 */
export const formatText = (str) => {
  // 用 /n 分割
  if (!str) return ''

  // 正则表达式匹配 /n前缀和/t分隔的部分
  const pattern = /\/n(css_[\w-]+) \/t([^\/n]+)/g
  let result = ''
  let lastIndex = 0

  // 使用 replace 解析匹配项
  str.replace(pattern, (match, cssClass, text, offset) => {
    // 追加前面的普通文本
    result += `<span>${str.slice(lastIndex, offset).replace(/\/n/g, '')}</span>`

    // 处理 class 名称，转换 `_` 为 ` `（符合你的要求）
    let formattedClass = cssClass.replace('_', ' ')

    // 追加带样式的文本
    result += `<span class="${formattedClass}">${text}</span>`

    lastIndex = offset + match.length
  })

  // 追加剩余的普通文本，并去掉 `/n`
  if (lastIndex < str.length) {
    result += `<span>${str.slice(lastIndex).replace(/\/n/g, '')}</span>`
  }

  return result
}

/**
 * 格式化数字金额
 * @param {*} value
 * @returns
 */
export const formatterMoney = (value, dot = 2) => {
  if (!value) return Number(0).toFixed(dot)

  return value
    .toFixed(dot)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}



// WEBPACK FOOTER //
// ./src/libs/utils/index.js